import { render, staticRenderFns } from "./DoctorRegisterHospitalOrderModal.vue?vue&type=template&id=40dca350&scoped=true&"
import script from "./DoctorRegisterHospitalOrderModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterHospitalOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterHospitalOrderModal.vue?vue&type=style&index=0&id=40dca350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dca350",
  null
  
)

export default component.exports